import { SVGAttributes } from 'react';

type Props = SVGAttributes<SVGElement>;

export function IconDone(props: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            data-testid="IconDone"
            {...props}
        >
            <path d="M9.00012 16.1999L5.50012 12.6999C5.11012 12.3099 4.49012 12.3099 4.10012 12.6999C3.71012 13.0899 3.71012 13.7099 4.10012 14.0999L8.29012 18.2899C8.68012 18.6799 9.31012 18.6799 9.70012 18.2899L20.3001 7.69995C20.6901 7.30995 20.6901 6.68995 20.3001 6.29995C19.9101 5.90995 19.2901 5.90995 18.9001 6.29995L9.00012 16.1999Z" />
        </svg>
    );
}
